import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, OnInit, OnDestroy, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router, RouterLink, RouterLinkActive, RouterModule } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';

import { SplashScreen } from '@capacitor/splash-screen';
import { StatusBar, Style } from '@capacitor/status-bar';

import { Storage } from '@ionic/storage-angular';
import { initializeApp } from 'firebase/app';
import { App } from '@capacitor/app';



import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MenuController,
  NavController,
  Platform,
  ToastController,
} from '@ionic/angular/standalone';
import { UserService } from './providers/user.service';
import { AlertController, IonicModule, ModalController, } from '@ionic/angular';
import { CommonModule, DatePipe } from '@angular/common';
import { EventsService } from './services/events.service';
import { ApiProvider } from '../providers/api/api';
import { HttpClient } from '@angular/common/http';
import OneSignal from 'onesignal-cordova-plugin';
import { Capacitor } from '@capacitor/core';
import { LanguageModal } from './pages/language-modal/language-modal';


const firebaseConfig = {
  apiKey: "AIzaSyAYpgIGKfXPLNV5oeM-8iso5o-VLmU_rw0",
  authDomain: "hscodes2022march.firebaseapp.com",
  databaseURL: "https://hscodes2022march-default-rtdb.firebaseio.com",
  projectId: "hscodes2022march",
  storageBucket: "hscodes2022march.appspot.com",
  messagingSenderId: "229782254017",
  appId: "1:229782254017:web:feb27fa3fc34a2f01fbf40",
  measurementId: "G-DZRJYZDJPV",
};

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,

  imports: [
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    CommonModule,
    RouterModule,


  ],
  providers: [DatePipe],
  encapsulation: ViewEncapsulation.None,
  schemas: [CUSTOM_ELEMENTS_SCHEMA], // 🔥 REQUIRED

})
export class AppComponent implements OnInit, OnDestroy {
  private router = inject(Router);
  private storage = inject(Storage);
  private userService = inject(UserService);
  private swUpdate = inject(SwUpdate);
  private toastCtrl = inject(ToastController);
  private menu = inject(MenuController);
  private platform = inject(Platform);
  private navCntrl = inject(NavController)
  private modalCtrl = inject(ModalController)
  private backButtonListener: any;

  appPages = [
    { id: 1, header: 'Select Language', url: null, icon: '../assets/sidemenu/language.png' },
    { id: 2, header: 'About', url: '/about', icon: '../assets/sidemenu/about.jpg' },
    { id: 3, header: 'Home', url: '/home', icon: '../assets/sidemenu/home.png' },
    { id: 4, header: 'Search', url: '/search', icon: '../assets/sidemenu/search.png' },
    { id: 5, header: 'Profile', url: '/profile', icon: '../assets/sidemenu/user.png' },
    { id: 6, header: 'HS-CRM', url: '/hscrm', icon: '../assets/sidemenu/crm.png' },
    { id: 7, header: 'Favourites', url: '/favourites', icon: '../assets/sidemenu/love.png' },
    { id: 8, header: 'Notifications', url: '/notifications', icon: '../assets/sidemenu/notification-bell.png' },
    { id: 9, header: 'Request Franchise', url: '/franchise-request', icon: '../assets/sidemenu/franchise-agreement.png' },
    { id: 10, header: 'WEF - Agent Request Form', url: '/agency-request', icon: '../assets/sidemenu/agency.png' },
    { id: 11, header: 'Buyer', url: '/buyers', icon: '../assets/sidemenu/buyer.png' },
    { id: 12, header: 'Subscription', url: '/subscription', icon: '../assets/sidemenu/subscribe.png' },
    { id: 13, header: 'Service Subscription', url: '/service-subscription', icon: '../assets/sidemenu/subscription.png' },
    { id: 14, header: 'Users Location On Map', url: '/maps', icon: '../assets/sidemenu/pin.png' },
    { id: 15, header: 'App Demo Videos', url: '/videos', icon: '../assets/sidemenu/play.png' },
    { id: 16, header: 'SVR TOOLKIT', url: '/login', icon: '../assets/sidemenu/tool-box.png' },
    { id: 17, header: 'Contact Us', url: '/contact', icon: '../assets/sidemenu/contact.jpg' },
    { id: 18, header: 'Terms & Conditions', url: '/terms', icon: '../assets/sidemenu/direct-download.png' },
    { id: 19, header: 'Logout', icon: '../assets/sidemenu/logout.png' },
  ];


  loggedIn = false;
  dark = false;
  selected_country        // actual country object
  is_manual_country 

  async ngOnInit() {    
    this.platform.ready().then(() => {
      this.checkLoginstatus();
    });
    this.initializeApp();
    await this.storage.create();
    this.checkLoginStatus();

    this.listenForLoginEvents();

    this.swUpdate.versionUpdates.subscribe(async () => {
      const toast = await this.toastCtrl.create({
        message: 'Update available!',
        position: 'bottom',
        buttons: [
          {
            role: 'cancel',
            text: 'Reload',
          },
        ],
      });

      await toast.present();

      toast
        .onDidDismiss()
        .then(() => this.swUpdate.activateUpdate())
        .then(() => window.location.reload());
    });
  }

  async onItemClick(item: any) {
    if (item.header === 'Logout') {
      this.logOutAlert();
    }
    else if (item.header === 'Select Language') {
      const modal = await this.modalCtrl.create({
        component: LanguageModal,
        // breakpoints: [0, 0.5, 0.9],
        // initialBreakpoint: 0.9,
        backdropDismiss: true,
        cssClass: 'language-modal'
      });

      await modal.present();

      const { data } = await modal.onWillDismiss();
      if (data) {
        this.applyLanguage(data.code);
      }
    }
  }

  applyLanguage(langCode: string) {
    const select = document.querySelector('.goog-te-combo') as HTMLSelectElement;

    if (select) {
      select.value = langCode;
      select.dispatchEvent(new Event('change'));
    }
  }


  checkLoginStatus() {
    return this.userService.isLoggedIn().then(loggedIn => {
      return this.updateLoggedInStatus(loggedIn);
    });
  }
  async checkLoginstatus() {

    const loggedIn = await this.userService.isLoggedIn();
    if (!loggedIn) {
      this.router.navigateByUrl('/tutorial', { replaceUrl: true });
      return;
    }
  }


  updateLoggedInStatus(loggedIn: boolean) {
    setTimeout(() => {
      this.loggedIn = loggedIn;
    }, 300);
  }

  listenForLoginEvents() {
    window.addEventListener('user:login', () => {
      this.updateLoggedInStatus(true);
    });

    window.addEventListener('user:signup', () => {
      this.updateLoggedInStatus(true);
    });

    window.addEventListener('user:logout', () => {
      this.updateLoggedInStatus(false);
    });
  }

  logout() {
    this.userService.logout().then(() => {
      localStorage.clear();
      return this.router.navigateByUrl('/signin');
    });
  }

  openTutorial() {
    this.storage.set('ion_did_tutorial', false);
    this.router.navigateByUrl('/tutorial');
  }

  toggleDarkMode() {
    document.documentElement.classList.toggle('ion-palette-dark', this.dark);
  }

  country_code: any; attempt: any;
  rootPage: any;
  showSplash = true;
  pages: Array<{ title: string, component: any, icon: any }>;
  lat: any;
  lng: any;
  showedAlert: boolean;
  currentaddr: any = {};
  count: any;
  currentdate: any;
  package_name: number = 0;
  country: any;
  confirmAlert: any;
  geo_country_id: any;
  ip_address: any; profiledetails: any; getdata: any;
  // private geolocation: Geolocation,
  constructor(private datePipe: DatePipe, private events: EventsService, private alertCtrl: AlertController, private apiProvider: ApiProvider, private http: HttpClient) {
    var myDate = new Date().toISOString();
    this.currentdate = this.datePipe.transform(myDate, 'yyyy-MM-dd');
    console.log(this.currentdate);

    events.subscribe('user:signedIn', (userEventData) => {
      console.log(userEventData);

      this.profiledetails = userEventData[0];
      console.log(this.profiledetails);

      var usrData = userEventData[0].reportdata.filter(word => word.chapterend >= this.currentdate);
      console.log(usrData);
      if (usrData.length != 0) {
        console.log(usrData);
        var array3 = usrData.map(obj => obj.package_indicator).sort()
        console.log(array3);
        this.package_name = array3[0];

      }
      console.log(this.package_name);

    });


    if (JSON.parse(localStorage.getItem('user_data'))) {

      this.getdata = JSON.parse(localStorage.getItem('user_data'));
      // var userData = JSON.parse(localStorage.getItem('user_data'));
      // console.log(userData);
      if (this.getdata.role != 'AGENT') {
        var usrData = this.getdata[0].reportdata.filter(word => word.chapterend >= this.currentdate);
        console.log(usrData);
        if (usrData.length != 0) {
          console.log(usrData);
          var array3 = usrData.map(obj => obj.package_indicator).sort()
          console.log(array3);
          this.package_name = array3[0];

        } else {
          this.package_name = 0;
        }
        this.profiledetails = this.getdata[0];
        console.log(this.profiledetails);

        console.log(this.profiledetails);
      } else {
        this.profiledetails = JSON.parse(localStorage.getItem('user_data'));
      }
    } else {
      this.profiledetails = [];
    }

  }
  initializeApp() {
    this.platform.ready().then(() => {
      StatusBar.setStyle({ style: Style.Dark });
      SplashScreen.hide();
      StatusBar.setOverlaysWebView({ overlay: false });
    });

    this.platform.ready().then(() => {
      // Reset to English when app starts
      this.resetToEnglish();

      // Reset to English when app resumes from background
      this.platform.resume.subscribe(() => {
        this.resetToEnglish();
      });

      // Reset to English when app pauses (goes to background)
      this.platform.pause.subscribe(() => {
        this.resetToEnglish();
      });
    });
  
    const loc_id = JSON.parse(localStorage.getItem('user_data'));
  
    if (loc_id) {
      if (loc_id.role != 'AGENT') {
        initializeApp(firebaseConfig);
  
        setTimeout(() => {
          this.showSplash = false;
          this.navCntrl.navigateRoot('/home');
        }, 3000);
  
        // ✅ Only run geo-location if manual country is NOT set
        const isManual = localStorage.getItem('is_manual_country');
        if (!isManual) {
          this.loadGeoCountry();
        } else {
          console.log('Manual country selected, skipping geo initialization');
        }
  
      } else {
        setTimeout(() => {
          this.showSplash = false;
          this.navCntrl.navigateRoot('/agenthomePage');
        }, 3000);
      }
  
    } else {
      this.showSplash = false;
      this.router.navigate(['/signin']);
      this.http.get('https://api.ipify.org?format=json')
        .subscribe((res: any) => {
          localStorage.setItem('ip_address', res.ip);
        });
    }
  
    if (Capacitor.isNativePlatform()) {
      this.initOneSignal();
    }
  
    this.registerBackButton();
  }

  initOneSignal() {
    if (!Capacitor.isNativePlatform()) return;
  
    try {
      // 🔹 Initialize OneSignal (App ID for Android + iOS)
      OneSignal.initialize('4384a65c-4b5f-44c0-93cb-a5c49ce2d062');
  
      // 🔹 Request push notification permission
      OneSignal.Notifications.requestPermission(true);
  
      // 🔹 Handle foreground notifications
      OneSignal.Notifications.addEventListener('foregroundWillDisplay', event => {
        // show notification while app is in foreground
        event.preventDefault();
        event.getNotification().display();
      });
  
      // 🔹 Handle notification opened
      OneSignal.Notifications.addEventListener('click', event => {
        console.log('Notification opened:', event);
        // Optional: navigate to page
      });
  
      // 🔹 Get player ID
      OneSignal.User.getOnesignalId().then(onesignalId => {
        if (onesignalId) {
          localStorage.setItem('player_id', onesignalId);
          console.log('Player ID:', onesignalId);
        }
      });
  
    } catch (e) {
      console.error('OneSignal init error', e);
    }
  }
   

  loadGeoCountry() {
    fetch("https://api.geoapify.com/v1/ipinfo?&apiKey=83400769335141dfaa7633dad23dfb74")
      .then(res => res.json())
      .then(result => {
        this.apiProvider.getCountryid(result.country.iso_code)
          .subscribe((res: any) => {
            this.geo_country_id = res.data[0].country_id;
            if (!localStorage.getItem('geo_country_id')) {
              localStorage.setItem('geo_country_id', this.geo_country_id);
              localStorage.setItem('currency_country_id', this.geo_country_id);
            }
          });
      })
      .catch(err => console.log('Geo fetch error', err));
  }
  
  

  registerBackButton() {
    this.backButtonListener = App.addListener('backButton', async ({ canGoBack }) => {

      const currentUrl = this.router.url;

      // 🔹 HOME PAGE CHECK
      if (currentUrl === '/home') {

        if (canGoBack) {
          window.history.back();
        } else {
          this.showExitConfirm();
        }

      } else {
        window.history.back();
      }

    });
  }

  async showExitConfirm() {
    const alert = await this.alertCtrl.create({
      header: 'Oh No!',
      message: 'Are you sure you want to Exit?',
      mode: 'ios',
      buttons: [
        {
          text: 'No',
          role: 'cancel'
        },
        {
          text: 'Yes',
          handler: () => {
            App.exitApp();
          }
        }
      ]
    });

    await alert.present();
  }

  menuRadius() {
    setTimeout(() => {
      document.querySelector('ion-menu').shadowRoot.querySelector('.menu-inner').setAttribute('style', 'border-radius:0px 50px 0px 0px');
    }, 2000);
  }

  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    this.navCntrl.navigateBack(page.component);
  }
  LogOut() {
    this.logOutAlert();
  }

  async logOutAlert() {
    var usr_ph = localStorage.getItem('usr_ph');
    var usr_password = localStorage.getItem('usr_password');
    this.showedAlert = true;
    this.confirmAlert = await this.alertCtrl.create({
      cssClass: 'my-custom-class',
      subHeader: 'Are you sure you want to Logout?',
      mode: 'ios',
      buttons: [{
        text: 'No',
        handler: () => {
        }
      }, {
        text: 'Ok',
        handler: () => {
          localStorage.clear();
          localStorage.setItem("usr_ph", usr_ph);
          localStorage.setItem("usr_password", usr_password);
          this.navCntrl.navigateRoot('/signup');
          localStorage.removeItem('user_data');
          localStorage.removeItem('current_country');
          localStorage.removeItem('usr_ph');


        }
      },
      ]
    });
    this.confirmAlert.present();
  }

  ngOnDestroy() {
    if (this.backButtonListener) {
      this.backButtonListener.remove();
    }
  }

  resetToEnglish() {
    // Remove Google Translate cookies
    document.cookie = 'googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    document.cookie = 'googtrans=/en/en; path=/;';
    
    // Reset the translate element
    const translateElement = document.querySelector('.goog-te-combo') as HTMLSelectElement;
    if (translateElement) {
      translateElement.value = '';
      translateElement.dispatchEvent(new Event('change'));
    }

    // Reload if language was changed
    const htmlLang = document.documentElement.lang;
    if (htmlLang && htmlLang !== 'en') {
      window.location.reload();
    }
  }

}


